import { render } from "./ConfigTemplates.vue?vue&type=template&id=3b78d17c"
import script from "./ConfigTemplates.vue?vue&type=script&lang=js"
export * from "./ConfigTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__